import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/logo2.png";
import "./style.css";


function Navbar(props){

    const navigate = useNavigate();

    function Logout(){
        localStorage.removeItem("sessionToken");
        localStorage.removeItem("sessionId");
        localStorage.removeItem("sessionEmail");
        localStorage.removeItem("sessionNomePaciente");
        navigate('/login');
    }

    let classDefault = "btn btn-outline-light me-3"
    let classSelecionado = "btn btn-light me-3" 

    return <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-danger ps-1 pe-1">
    <div className="container-fluid">
        <a className="navbar-brand" href="/"><img className="mt-1" src={Logo} alt="SAP" /></a>
        
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
            
                            
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                <Link className={props.tela === "/" ? classSelecionado : classDefault} aria-current="page" to="/"><i className="fas fa-home"></i>Início</Link>
                </li>                
            </ul>

            <div className="btn-group">
                <button type="button" className="btn btn-outline-light me-3 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="fas fa-user"></i> {localStorage.getItem('sessionNomePaciente')} 
                </button>
                <ul className="dropdown-menu dropdown-menu-end">                    
                    <li><Link to="/senha" className="dropdown-item">Alterar Senha</Link></li>
                    <li><hr className="dropdown-divider" /></li>
                    <li><button className="dropdown-item" onClick={Logout} type="button">Sair</button></li>
                </ul>
            </div>

            

        </div>
    </div>
</nav>
}

export default Navbar;